import { atom } from "recoil";

export const productsForDropDownList = atom({
  key: "productsForDropDownList",
  default: [],
});
